import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';

const api = {
  getBrandDataList: (params) => {
    return sendAxios({
      method: 'GET',
      url: '/brand/page/catalog',
      params,
      baseURL: Domains.lcscListUrl,
    });
  },
};
export default api;
